import React from "react";
import IndexNavbar from "components/Navbars/IndexNavbar";

const ZipLockTerms = () => {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const headingStyle = { fontSize: "22px", fontWeight: "600", color: "#222", marginTop: "30px" };
  const textStyle = { fontSize: "16px", fontWeight: "400", color: "#444", lineHeight: "1.8", marginTop: "10px" };
  const smallTextStyle = { fontSize: "14px", fontWeight: "400", color: "#666" };

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <div className="main">
          <div className="section section-basic" style={{ paddingTop: "120px" }}>
            <div className="container" style={{ maxWidth: "900px" }}>
              <h1 style={{ fontSize: "32px", fontWeight: "700", color: "#111", textAlign: "center" }}>
                Terms of Use
              </h1>
              <p style={{ ...smallTextStyle, textAlign: "center", marginTop: "10px" }}>
                Ziipper Lock - BUGUN SOFTWARE COMPANY LIMITED
              </p>

              <div style={{ marginTop: "40px" }}>
                <h3 style={headingStyle}>1. Acceptance of Terms</h3>
                <p style={textStyle}>
                  By downloading, installing, or using Ziipper Lock ("App"), you
                  agree to comply with and be bound by these Terms of Use. If
                  you do not agree with these terms, please do not use the App.
                </p>

                <h3 style={headingStyle}>2. Description of Service</h3>
                <p style={textStyle}>
                  Ziipper Lock provides a visual zipper overlay effect displayed
                  on top of other applications using the "Display over other
                  apps" permission. The App is designed for personalization and
                  entertainment purposes only.
                </p>

                <h3 style={headingStyle}>3. User Responsibilities</h3>
                <p style={textStyle}>
                  You agree to use the App only for lawful purposes and in a way
                  that does not infringe the rights of others or restrict their
                  use of their devices.
                </p>
                <p style={textStyle}>
                  You are responsible for managing app permissions through your
                  device settings.
                </p>

                <h3 style={headingStyle}>4. Permissions</h3>
                <p style={textStyle}>
                  The App requires "Display over other apps" permission to
                  function properly. By granting this permission, you
                  acknowledge and consent to the overlay functionality.
                </p>

                <h3 style={headingStyle}>5. Intellectual Property</h3>
                <p style={textStyle}>
                  All content, design, graphics, and functionality of Ziipper
                  Lock are the property of BUGUN SOFTWARE COMPANY LIMITED
                  and are protected by applicable intellectual property laws.
                </p>

                <h3 style={headingStyle}>6. Limitation of Liability</h3>
                <p style={textStyle}>
                  The App is provided "as is" without warranties of any kind.
                  BUGUN SOFTWARE COMPANY LIMITED shall not be liable for any
                  direct, indirect, incidental, or consequential damages arising
                  from the use or inability to use the App.
                </p>

                <h3 style={headingStyle}>7. Modifications</h3>
                <p style={textStyle}>
                  We reserve the right to modify or discontinue the App at any
                  time without prior notice. We may also update these Terms of
                  Use from time to time.
                </p>

                <h3 style={headingStyle}>8. Termination</h3>
                <p style={textStyle}>
                  We may terminate or suspend access to the App if you violate
                  these Terms of Use.
                </p>

                <h3 style={headingStyle}>9. Contact Information</h3>
                <p style={textStyle}>
                  If you have any questions regarding these Terms of Use,
                  please contact:
                </p>
                <p style={textStyle}>
                  <strong>Company Name:</strong> BUGUN SOFTWARE COMPANY LIMITED
                </p>
                <p style={textStyle}>
                  <strong>Email:</strong> thanglvan@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ZipLockTerms;
